import React from 'react'
import UserInfo from './Authorization/UserInfo'

export const RequireAuth = ({allowedRoles, permissions, children}) => {  
    const userData = UserInfo()
    const userRole = userData?.role

    // Handle investor auth separately — investor uses investorAuthToken, not authToken
    if (allowedRoles?.includes('INVESTOR')) {
      const investorToken = localStorage.getItem('investorAuthToken');
      const investorUser = localStorage.getItem('investorUser');
      if (investorToken && investorUser) {
        return(children)
      }
      return <h1> You do not have enough permissions ! </h1>
    }

    // Handle founder auth separately — founder uses founderAuthToken, not authToken
    if (allowedRoles?.includes('FOUNDER')) {
      const founderToken = localStorage.getItem('founderAuthToken');
      const founderUser = localStorage.getItem('founderUser');
      if (founderToken && founderUser) {
        return(children)
      }
      return <h1> You do not have enough permissions ! </h1>
    }

    // var is_allowed = userData?.role?.some(allowed_role => allowedRoles?.includes(allowed_role))

    
    var is_allowed = userRole && allowedRoles.some(role => userRole.includes(role));
    // var has_perm = permissions?.includes(userData?.permissions)
    var has_perm = !permissions || permissions.length === 0 || permissions.some(perm => userData?.permissions?.includes(perm))

    if (is_allowed && has_perm && allowedRoles.includes(userData.active_role)){
      return(children)
    }
    else{
      return <h1> You do not have enough permissions ! </h1>
    }
  }

